
export default function isAccountRegisterUrlLocationUtil () {
  return window.location.pathname === '/account/register'
}
